/**
 * AuthLayout — shell de marque des pages publiques (login, signup, reset…).
 *
 * @remarks
 * La zone auth est un "moment de marque" pré-login. On y force le thème
 * **sombre** sur le sous-arbre (`data-theme="dark"`) indépendamment de la
 * préférence utilisateur, on scope l'accent fonctionnel sur l'indigo de marque
 * via `[data-auth-zone]`, et on force la police de marque Schibsted Grotesk
 * (`font-brand`) sur le corps — seuls les titres passent en Clash (cf.
 * `tokens.css`). C'est le seul endroit où l'on déroge à la règle "l'utilisateur
 * possède son apparence" — assumé (cf. SAAS-631).
 *
 * Le fond de marque (halos indigo + grain + vignette) est centralisé ici via
 * `AuthBackground` et partagé par toutes les vues : celles-ci ne rendent plus
 * que leur colonne (logo + carte), centrée par ce layout.
 *
 * Les vues d'auth sont chargées à la demande : le `<Suspense>` garde le fond de
 * marque affiché pendant leur chargement, avec un indicateur, au lieu d'un
 * écran vide (SAAS-984).
 */

import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Spinner } from '@/shared/ui';
import { AuthBackground } from './AuthBackground';

export function AuthLayout() {
  return (
    <div
      data-auth-zone
      data-theme="dark"
      className="bg-bg text-fg font-brand relative flex min-h-screen w-full items-center justify-center overflow-x-clip px-4 py-10"
    >
      <AuthBackground />
      <Suspense
        fallback={
          <div className="text-fg-secondary relative z-10">
            <Spinner size="lg" label="Chargement de la page" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </div>
  );
}
